<template>
  <div>
    <WebHeaderView :title="$t('menu.recharge')" />
    <div class="page-content">
      <div class="type-box">
        <van-grid :border="false">
          <van-grid-item v-for="(item, index) in rechargeType" :key="index">
            <div
              style="width: 100%; position: relative; padding-bottom: 10px"
              :class="usrIndex == index ? 'selectd' : ''"
              @click="selectItem(item, index)"
            >
              <img
                :src="item.logo"
                style="width: 37px; height: 37px; margin: 8px auto"
              />
              <p>{{ item.name }}</p>
              <span style="color: red; font-size: 14px"
                >{{ item.min_price }} ~ {{ item.max_price }}</span
              >
              <div class="select-icon" v-if="usrIndex == index">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 32 32"
                  class="h-5 w-5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 16.5L32 0V22C32 27.5228 27.5228 32 22 32H0L15 16.5Z"
                    fill="#cca352"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M26.2438 17.0091C26.4403 17.1401 26.5767 17.3438 26.623 17.5754C26.6693 17.807 26.6218 18.0475 26.4908 18.2441L20.5533 27.1503C20.4801 27.2598 20.3836 27.3518 20.2707 27.4195C20.1577 27.4873 20.0312 27.5292 19.9001 27.5421C19.769 27.555 19.6367 27.5388 19.5127 27.4944C19.3887 27.4501 19.276 27.3788 19.1829 27.2857L15.6204 23.7232C15.4631 23.5543 15.3774 23.331 15.3815 23.1003C15.3856 22.8696 15.479 22.6494 15.6422 22.4862C15.8054 22.3231 16.0255 22.2296 16.2563 22.2255C16.487 22.2215 16.7103 22.3071 16.8791 22.4644L19.6733 25.2586L25.0088 17.2549C25.14 17.0585 25.3438 16.9224 25.5754 16.8763C25.807 16.8302 26.0474 16.8779 26.2438 17.0091Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </div>
          </van-grid-item>
        </van-grid>
        <div style="font-size: 13px; color: red">
          {{ selectType.recharge_desc }}
        </div>
      </div>
      <div v-if="selectType.type == 4">
        <div class="post-btn" style="width: 96% !important; margin: 20px auto" @click="openNativePage()">
          联系客服
        </div>
        
      </div>
      <div v-else>
      <div class="aisle" :class="isshow ? '' : 'aisle-height'">
        <ul>
          <li
            style="float: left"
            v-for="(item, index) in aisle"
            :key="index"
            @click="SelectAisle(item, index)"
          >
            <div class="item" :class="aisleindex == index ? 'selectd' : ''">
              <img :src="selectType.logo" />
              <div>{{ item.name }}</div>
            </div>
          </li>
          <li style="clear: both" />
        </ul>
        <div style="clear: both" />
      </div>
      <div style="font-size: 14px; color: #cca352" @click="isshow = !isshow" v-if="aisle && aisle.length > 4"> 
        <a v-if="!isshow">展开<van-icon name="arrow-down" /></a
        ><a v-else>收起<van-icon name="arrow-up" /></a>
      </div>
      <div class="num">
        <div class="title">充值金额</div>
        <van-field
          v-model="frm.amount"
          type="number"
          :placeholder="
            '限额：' + selectType.min_price + ' ~ ' + selectType.max_price + ''
          "
        >
          <template #right-icon>元</template>
        </van-field>
        <div class="mode">
          <ul>
            <li
              class="qamount"
              v-for="(item, index) in selectaisle.fixed_amounts"
              :key="index"
              @click="frm.amount = item"
            >
              {{ item }}
            </li>
            <li></li>
          </ul>
        </div>
        <div style="clear: both" />
        <div class="desc">
          注意：请以实际支付的汇率为准，到账金额为提交订单时的RMB金额
        </div>
      </div>
      <div>
        <div class="post-btn" style="width: 96% !important; margin: 20px auto" @click="toDoRecharge">
          下一步
        </div>
        <p style="font-size: 14px; margin-top: 30px">
          存款遇到问题？联系<span
            style="color: rgb(204, 163, 82)"
            @click="openNativePage()"
            >在线客服</span
          >处理
        </p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'RechargeView',
  components: {
    WebHeaderView
  },
  data () {
    return {
      isshow: false,
      usrIndex: 0,
      rechargeType: [],
      selectType: {},
      aisleindex: 0,
      aisle: [],
      selectaisle: {},
      frm: {
        aisle_id: null,
        amount: null
      }
    }
  },
  mounted () {
    this.GetRechargeType()
  },
  methods: {
    async GetRechargeType () {
      await this.$http({
        method: 'get',
        url: 'rechargetype'
      }).then(data => {
        this.rechargeType = data.data
        this.selectType = data.data[0]
        if(this.rechargeType[0] && this.rechargeType[0].id)
          this.GetRechargeAisle(this.rechargeType[0].id)
      })
    },
    selectItem (item, index) {
      this.selectType = item
      this.usrIndex = index
      this.GetRechargeAisle(item.id)
    },
    async GetRechargeAisle (id) {
      
      this.aisle = []
      await this.$http({
        method: 'get',
        url: 'rechargeaisle',
        data: { recharge_type_id: id }
      }).then(data => {
        if(data.data && data.data.length > 0){
        this.aisle = data.data
        this.aisleindex = 0
        this.selectaisle = this.aisle[0]
        this.frm.aisle_id = this.selectaisle.id
      }
      })
    },
    SelectAisle (item, index) {
      if(item){
      this.aisleindex = index
      this.selectaisle = item
      this.frm.aisle_id = item.id
      }
    },
    async toDoRecharge () {
      if (!this.frm.aisle_id) {
        this.$toast.fail('请选择充值方式！')
        return
      }
      if (!this.frm.amount) {
        this.$toast.fail('请填写或选择充值金额！')
        return
      }
      await this.$http({
        method: 'post',
        url: 'dorecharge',
        data: this.frm
      }).then(data => {
        this.jumpUrl(data.data.pay_url)
        this.frm.amount = null
        this.amountIndex = null
      })
    },
    jumpUrl (url) {
      const _u = navigator.userAgent
      const ios = _u.indexOf('iPhone') > -1
      const iPad = _u.indexOf('iPad') > -1
      if (ios || iPad) {
        window.location.replace(url)
      } else {
        if (url.includes('https://')) {
          window.open(url)
        } else {
          window.location.href = url
        }
      }
    },
    checkDevice () {
      const u = navigator.userAgent
      return {
        isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      }
    },
    isIOS () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    },
    openNativePage () {
      const device = this.checkDevice()
      if (device.isAndroid) {
        // this.callAndroidMethod('toKeFu', { page: 'toKeFu' })
        let targetUserId = '1'; 
        let apiObjectName = '_dsbridge';
        if (window[apiObjectName] && window[apiObjectName].toKefu) {
          window[apiObjectName].toKefu(targetUserId); 
        } else {
          this.$toast.fail('Android方法未注入')
        }

      } else if (this.isIOS()) {
        if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openBrowser){
          try {
            window.webkit.messageHandlers.openBrowser.postMessage('tokefu');
          } catch (error) {
            this.$toast.fail('IOS方法调用失败')
          }
        } else {
          this.$toast.fail('IOS方法未注入')
        }
        
        
        //this.callIOSMethod('toKeFu', { page: '' })
      } else {
        this.$router.push({ name: 'news'});
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.selectd {
  border: 1px solid #cca352 !important;
  color: #cca352 !important;
  border-radius: 10px;
}
.select-icon {
  position: absolute;
  right: 0px;
  bottom: -5px;
}
.aisle-height {
  height: 85px;
  overflow: hidden;
}
.aisle {
  width: 90%;
  margin: 20px auto;
  ul {
    width: 100%;
    list-style: none;
    li {
      float: left;
      min-width: 47%;
      margin-right: 10px;
      text-align: left;
      margin-bottom: 10px;
      div.item {
        height: 24px;
        line-height: 24px;
        border: 1px solid grey;
        padding: 4px 6px;
        border-radius: 10px;
        font-size: 13px;
        img {
          width: auto;
          height: 100%;
          float: left;
          margin-right: 8px;
        }
      }
    }
  }
}
.num {
  text-align: left;
  width: 96%;
  margin: 0 auto;
  div {
    margin-bottom: 10px;
  }
  .desc {
    font-size: 13px;
  }
  .mode {
    li.qamount {
      background: #222;
      height: 36px;
      line-height: 36px;
      color: #fff;
      border: 1px solid grey;
      border-radius: 8px;
      margin-left: 10px;
      margin-bottom: 10px;
      width: 22%;
      text-align: center;
      float: left;
    }
  }
}
</style>
<style>
.num .van-cell {
  background-color: #222 !important;
}
.num .van-field__control {
  color: #fff !important;
}
</style>
